import { Component, effect, input, ChangeDetectionStrategy, computed } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { Permission, Node } from '@xanadu/model';

@Component({
    selector: 'app-security',
    templateUrl: './security.component.html',
    styleUrls: ['./security.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SecurityComponent {
    formGroup = input<FormGroup>();
    node = input<Node>();
    permission = input<Permission>();
    readonly = input<boolean>();

    metaName: any = { id: 'name', name: 'Permission' };
    metaRoles: any = { id: 'roles', name: 'Roles', info: 'Roles assigned' };
    keys: string[] = [];

    permissionArray?: FormArray<any>;

    constructor(
    ) {
        effect(() => {
            const permission = this.permission()
            const formGroup = this.formGroup();

            if (permission && formGroup) {
                this.keys.length = 0;
                this.permissionArray = new FormArray<any>([]);

                for (let key in permission) {
                    this.keys.push(key);
                    this.permissionArray.push(new FormGroup({}));
                }

                formGroup.addControl('permissions', this.permissionArray);
            }
        });
    }
}
